import Vue from 'vue';
import { helper } from './Helper.js';


class FileSave{
  constructor(){
  }
  
saveBase64ToFile(base64Data, fileName){


    // check if the filename has the correct extension
    var extension="";
    if(base64Data.includes('application/pdf')){
      extension=".pdf";
    }
    if(base64Data.includes('image/png')){
      extension=".png";
    }
    if(base64Data.includes('image/jpg')){
      extension=".jpg";
    }
    // lets always append right extension name at end of file name
    if(!fileName.includes(extension)){
      fileName+=extension;
    }


    
    this._browser(base64Data, fileName); // returning promise when done
    
    
    
}





  _browser(base64Data, fileName){

        fileName = helper.sanatizeFilename(fileName);
       
        var link = document.createElement('a');
        link.href = base64Data;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(()=>{
          Vue.$toaster.toast("language.file_download_success");
        },1500);
       
        
  }

  /*
  _mobile(base64Data, fileName){

    fileName= helper.sanatizeFilename(fileName);

    // get file entry on mobile
    this.getFileEntryFromFilesystem(fileName).then(
      async (fileEntry)=>{

        this.mime= await this._getMime(fileEntry);
        var blob = this._base64DataToBlob(base64Data);

        
        setTimeout(()=>{
          this.writeFile(fileEntry, blob);
        },500)

      },
      ()=>{
        // error
        alert("FileSave: error getting fileentry")
        
      })

  }
  */






  // reserving a file entry on the system to download data in.
  // this works on mobile
  /*
  async getFileEntryFromFilesystem(fileName){
   
   
    var fs;
    var fileEntry;
     switch(window.cordova.platformId){
      case "ios":
        // never mind on ios.... wont be visible anyway
        //dir=window.cordova.file.documentsDirectory;
        this.dir=window.cordova.file.documentsDirectory; // download to clearable directory, then present save dialog
        
      break;
      case "android":
        // downloads in files/internalstorage/download
        // public shared dir on sd card 
        this.dir=window.cordova.file.externalRootDirectory+"/Download";
        
      break;
     }
     
     // directory is set for mobile
     // for ios/android
     // get filesystem

    //var directoryEntry = fs.root;
    //var folderName = "Folder";
    //directoryEntry.getDirectory(folderName, { create: true, exclusive: false }, onDirectorySuccess, onDirectoryFail);
    
     
     fs = await new Promise((resolve,reject)=>{
      window.resolveLocalFileSystemURL(this.dir, (fs)=>{

        // creating dir not working on ios.. android not tested
        //fs.getDirectory("WHAT", {create: true, exclusive:false}, (r)=>{alert("OKIDO"+r)},(e)=>{alert(e)});
        //console.log("resolveLocalFileSystemURL")
       
        resolve(fs);
      },(e)=>{
        reject();
        alert("FileSave: failed to get local file system to download file"+e.code)
      });
    })

    
    
    // get file to write to
    fileEntry = await new Promise((resolve,reject)=>{
      fs.getFile(fileName, { create: true, exclusive: false }, function (fileEntry) {
        resolve(fileEntry)
      },(err)=>{
        reject();
        alert("FileSave:fs.getFile() error: code "+err.code)
      })
    });
  
    
    return fileEntry;
  
    }
*/
/*
    writeFile(fileEntry, data) {
      //console.dir(fileEntry)
      // Create a FileWriter object for our FileEntry (log.txt).
      fileEntry.createWriter( (fileWriter)=>{
  
           fileWriter.onerror = (e) => {

           alert("FileSave: fileEntry.createWriter() error"+e.code)
            
            
           };
           
           var written = 0;
           var BLOCK_SIZE = 1*1024*1024; // write 1M every time of write
           var writeNext = (cbFinish)=>{
             
               fileWriter.onwrite = function() { // event
                   if (written < data.size)
                       writeNext(cbFinish);
                   else
                       cbFinish();
               };
               if (written) fileWriter.seek(fileWriter.length);
               fileWriter.write(data.slice(written, written + Math.min(BLOCK_SIZE, data.size - written)));
               written += Math.min(BLOCK_SIZE, data.size - written);
           }

           var writeFinish = ()=>{
            var success = () => {
             
              this.fileSaved(fileEntry)
              
             
              
            }
            var fail = (error)=>{
               alert("Filesave: error writeFinish()"+error.code)
            }
          fileEntry.file(success, fail);
           
        }


           // writing...
           writeNext(writeFinish);
           



       }); //fileEntry.createWriter
   }

*/











  _getMime(fileEntry){
    return new Promise((resolve)=>{
      fileEntry.file((data)=>{
        // return mime type
        resolve(data.type)
      })
    })
  }


   // file is saved on device, could be to temp directory
   /*
   async fileSaved(fileEntry){

    
    // only open non images
    if(this.mime=="image/jpeg" || this.mime=="image/png"){
      // android:: image should be downloaded to camera roll..
      if (window.cordova.platformId=="ios"){
        // ios:: present dialog to save file on ios
        this._openFile(fileEntry);
      }
    }else{
      this._openFile(fileEntry);
    }
      
      Vue.$toaster.toast("language.file_download_success");
      


   }
   */

   /*
  _openFile(fileEntry){
     
      // use file opener plugin to open file whit native pdf reader
      window.cordova.plugins.fileOpener2.showOpenWithDialog(
        fileEntry.toURL(),
        this.mime,
        {
            error : (e)=> {
              
                console.log('Error status: ' + e.status + ' - Error message: ' + e.message);
            },
            success : ()=>{
             
                console.log('file opened successfully');
            }
        }
      );
    
    
  }
  */

  _base64DataToBlob(dataurl) {
      
    var arr = dataurl.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]), n = bstr.length;
    var u8arr = new Uint8Array(n);

    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type:mime});
  }


}

export let fileSave = new FileSave();